import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import CTA from "../CTA/CTA";
import AgriTechStackBenefits from "./AgriTechStackBenefits";
import AgriTechStackFeatures from "./AgriTechStackFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";

// Main component for Cloud Gateway Stack
export default function AgriTechStack() {
  const data1 = [
    "AEP (Standard Gateway): Provides an API for third parties to access farm data and route it to their own servers for analytics and business intelligence. It receives data asynchronously from SEP but invokes SEP services synchronously.",
    "Messaging Service: In the context of the cloud gateway, a messaging service enables communication and data exchange between distributed applications, services, or components. It facilitates asynchronous communication, allowing different components of third-party applications and clouds to interact without requiring simultaneous availability.",
    "SEP: SEP in Cloud Gateway (part of SDH) enables seamless integration with third-party clouds and enterprise data centers, ensuring agnostic compatibility for efficient data exchange and enhancing SI Partners' flexibility.",
  ];

  const data2 = [
    "API: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
    "IAM: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
    "Third-Party Service: Third-party services refer to enterprise data center-hosted services or cloud solutions offered by major providers like AWS, Microsoft Azure, and Google Cloud Platform (GCP). They can also be part of an enterprise data center or standalone applications such as ERP or MES.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["Cloud Gateway Stack"]}
        bannerbodycopy="Enable interoperability and integration with third-party services and applications"
      />

      {/* Overview Section*/}
      <SolutionEcosystem title="Overview" type="Cloud" />

      {/*  Overview Features  Section*/}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features Section */}
      <AgriTechStackFeatures />
      {/* Benefits Section */}

      <AgriTechStackBenefits />

      {/* Call-to-Action */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href4="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}
